<script setup>
  const { event } = defineProps(['event']);
</script>

<!----------------------------------------------------------------------------->

<template>
  <div class="heading">
    <EventLogo small :event="event" />
    <h3>{{ event.fight_title }}</h3>
  </div>
  <h2>
    <FightTitleCombo>
      <template v-slot:whiteCorner>{{ event.white_corner?.last_name ?? 'TBD' }}</template>
      <template v-slot:blackCorner>{{ event.black_corner?.last_name ?? 'TBD' }}</template>
    </FightTitleCombo>
  </h2>
  <h3>{{ event.fight_title }}</h3>
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped>
  .heading {
    margin-top: px(148);

    display: flex;
    align-items: center;

    margin-bottom: px(20);
    gap: px(24);

    h3 {
      display: block;
    }
  }

  h3 {
    @include title-s;
    margin-bottom: -0.17em;

    display: none;
  }

  h2 {
  }

  @include break-medium {
    .heading {
      margin-top: px(109);
    }
  }

  @include break-small {
    .heading {
      flex-direction: column;

      margin-top: px(80);
      margin-bottom: px(24);

      h3 {
        display: none;
      }
    }

    h3 {
      display: block;
      margin-top: 8px;
    }

    h2 {
      align-self: stretch;
    }
  }

  @include break-phone {
    .heading {
      margin-top: 22vw;
    }
  }
</style>
